import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  countPageview,
  getGoatCounterEndpoint,
  getPageviewPath,
  loadGoatCounterScript,
  shouldLoadGoatCounter,
} from "./goatcounter";

export function GoatCounterAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!shouldLoadGoatCounter()) return undefined;

    const endpoint = getGoatCounterEndpoint();
    const path = getPageviewPath(location);
    let cancelled = false;

    loadGoatCounterScript(endpoint)
      .then(() => {
        if (!cancelled) countPageview(path);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [location]);

  return null;
}
